import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import * as _ from 'lodash';
import {bzIconChevronDown, bzIconChevronRight} from '@bringoz/ui/icons';
import {TimeCardModel} from '../../models/timecard.model';
import {TimeCardGroup} from '../../models/timecard-group.model';
import {TimeCardStatusType} from '../../../types/timecard-status.type';
import {TimekeepingColumnsMap} from '../../models/timekeeping-list.model';

export interface TimecardRowSelectEvent {
  timecard: TimeCardModel;
  group: TimeCardGroup;
  date?: Date;
}

const APPROVED_STATUSES: string[] = [TimeCardStatusType.Approved, TimeCardStatusType.Completed];

require('./timecard-table-row.scss');
@Component({
  standalone: false,
  selector: 'timecard-table-row',
  templateUrl: './timecard-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardTableRowComponent {

  readonly group = input<TimeCardGroup>();
  readonly index = input<number>();
  readonly isSelected = input<boolean>(false);
  readonly isIndeterminate = input<boolean>(false);
  readonly isExpanded = input<boolean>(false);
  readonly columns = input<TimekeepingColumnsMap>({});

  readonly timecardSelect = output<TimecardRowSelectEvent>();
  readonly expandToggle = output<TimeCardGroup>();
  readonly selectToggle = output<TimeCardGroup>();

  readonly hasInfeasibility = computed(() => _.some(this.group()?.timeCards, (timecard) => timecard.hasInfeasibility));
  readonly timeCardIds = computed(() => _.map(this.group()?.timeCards, 'id'));
  readonly isApproved = computed(() => _.includes(APPROVED_STATUSES, this.group()?.status));
  readonly icons = {expanded: bzIconChevronDown, collapsed: bzIconChevronRight};

  onToggleExpand(event: Event): void {
    event.stopPropagation();
    this.expandToggle.emit(this.group());
  }

  onRowSelect(): void {
    this.timecardSelect.emit({timecard: this.group()?.timeCards?.[0], group: this.group()});
  }

  onCheckboxToggle(): void {
    this.selectToggle.emit(this.group());
  }
}
